/**
 * Labstep
 *
 * @module components/EntityStateWorkflow/Action/ConfigureWorkflow/Trigger
 * @desc Configure Workflow trigger
 */

import { Can } from 'labstep-web/components/Entity/Can';
import { Action } from 'labstep-web/components/Entity/Can/types';
import { ENTITY_STATE_WORKFLOW_CONFIGURE_ROUTE_ID } from 'labstep-web/components/EntityStateWorkflow/Action/ConfigureWorkflow';
import { ICONS } from 'labstep-web/constants/icons';
import { ActionComponent } from 'labstep-web/core/Action/Component';
import { useHasFeatureFlagEnabled } from 'labstep-web/hooks/feature-flag';
import { useModalRoute } from 'labstep-web/hooks/modalRoute';
import type React from 'react';
import type { EntityStateWorkflowActionConfigureWorkflowTriggerProps } from './types';

export const EntityStateWorkflowActionConfigureWorkflowTrigger: React.FC<
  EntityStateWorkflowActionConfigureWorkflowTriggerProps
> = ({
  entityStateWorkflow,
  buttonType = 'text',
  buttonProps,
  text = 'Configure Workflow',
  showIcon,
  viewComponent,
}) => {
  const hasSignatureWorkflowFeatureEnabled = useHasFeatureFlagEnabled(
    'signature_workflow',
  );
  if (!hasSignatureWorkflowFeatureEnabled) {
    return null;
  }
  const { toggleModal } = useModalRoute(
    ENTITY_STATE_WORKFLOW_CONFIGURE_ROUTE_ID,
  );

  const state = {
    entityStateWorkflowId: entityStateWorkflow.id,
  };

  const defaultButtonProps: any = {
    type: buttonType,
    text,
    icon: ICONS.entity_state_workflow.settings,
    showIcon,
    ...buttonProps,
  };

  if (buttonType === 'button') {
    defaultButtonProps.elementProps = {
      basic: true,
      color: undefined,
    };
  }

  return viewComponent ? (
    viewComponent({
      toggleModal: () => {
        toggleModal(state);
      },
    })
  ) : (
    <Can
      entityName={entityStateWorkflow.entityName}
      id={entityStateWorkflow.id}
      action={Action.edit}
    >
      <ActionComponent
        {...defaultButtonProps}
        dataCy="components/EntityStateWorkflow/Action/ConfigureWorkflow/Trigger"
        onClick={() => toggleModal(state)}
      />
    </Can>
  );
};
